import React, { useEffect, useState } from 'react';
import { API } from '../api';

const emptyForm = {
  id: null,
  name: '',
  admin_id: null,
  admin_username: '',
  admin_name: '',
  admin_registration_number: '',
  admin_password: ''
};

export default function SuperAdmin({ token }) {
  const [organizations, setOrganizations] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const loadOrganizations = () => {
    fetch(`${API}/organizations`, { headers: { Authorization: token } })
      .then((res) => res.json())
      .then(setOrganizations)
      .catch(() => setError('Could not load organizations.'));
  };

  useEffect(() => {
    loadOrganizations();
  }, []);

  const updateForm = (key, value) => {
    setForm((current) => ({ ...current, [key]: value }));
  };

  const resetForm = () => {
    setForm(emptyForm);
    setEditing(false);
    setError('');
    setMessage('');
  };

  const startEdit = (organization) => {
    setForm({
      id: organization.id,
      name: organization.name,
      admin_id: organization.admin_id,
      admin_username: organization.admin_username || '',
      admin_name: organization.admin_name || '',
      admin_registration_number: organization.admin_registration_number || '',
      admin_password: ''
    });
    setEditing(true);
    setError('');
    setMessage('');
  };

  const saveOrganization = async () => {
    setError('');
    setMessage('');

    if (!form.name.trim() || !form.admin_username.trim() || !form.admin_name.trim() || (!editing && !form.admin_password.trim())) {
      setError(editing ? 'Organization name, admin username, and admin name are required.' : 'Organization name and admin credentials are required.');
      return;
    }

    const res = await fetch(`${API}/organizations${editing ? `/${form.id}` : ''}`, {
      method: editing ? 'PUT' : 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: token },
      body: JSON.stringify({
        name: form.name.trim(),
        admin: {
          id: form.admin_id,
          username: form.admin_username.trim(),
          name: form.admin_name.trim(),
          registration_number: form.admin_registration_number.trim() || null,
          password: form.admin_password
        }
      })
    });

    if (!res.ok) {
      setError('Could not save organization. The organization name, admin username, or registration number may already exist.');
      return;
    }

    setMessage(editing ? 'Organization updated.' : 'Organization created.');
    setForm(emptyForm);
    setEditing(false);
    loadOrganizations();
  };

  return (
    <div className="wideContainer">
      <h2>Superadmin</h2>
      {error && <p className="error">{error}</p>}
      {message && <p className="success">{message}</p>}

      <div className="profilesLayout">
        <section className="adminPanel">
          <h3>{editing ? 'Edit Organization' : 'Create Organization'}</h3>
          <input value={form.name} onChange={(e) => updateForm('name', e.target.value)} placeholder="Organization name" />
          <input value={form.admin_username} onChange={(e) => updateForm('admin_username', e.target.value)} placeholder="Admin username" />
          <input value={form.admin_name} onChange={(e) => updateForm('admin_name', e.target.value)} placeholder="Admin actual name" />
          <input
            value={form.admin_registration_number}
            onChange={(e) => updateForm('admin_registration_number', e.target.value)}
            placeholder="Admin registration number optional"
          />
          <input
            type="password"
            value={form.admin_password}
            onChange={(e) => updateForm('admin_password', e.target.value)}
            placeholder={editing ? 'New admin password optional' : 'Admin temporary password'}
          />
          <button onClick={saveOrganization}>{editing ? 'Save Organization' : 'Create Organization'}</button>
          {editing && <button className="secondaryButton" onClick={resetForm}>Cancel Edit</button>}
        </section>

        <section className="adminPanel">
          <h3>Organizations</h3>
          <div className="profileList">
            {organizations.map((organization) => (
              <div className="profileRow" key={organization.id}>
                <div>
                  <span>{organization.name}</span>
                  <small>Admin: {organization.admin_name || 'No admin configured'}</small>
                  {organization.admin_username && <small>Username: {organization.admin_username}</small>}
                </div>
                <button className="smallButton" onClick={() => startEdit(organization)}>Edit</button>
              </div>
            ))}
            {organizations.length === 0 && <p>No organizations yet.</p>}
          </div>
        </section>
      </div>
    </div>
  );
}
